"use client";

import React from "react";
import { PhotoModal } from "@/components/ui/photo-modal";

export default function MessageImageModal({
  open,
  onClose,
  imageUrls,
  imageIndex,
  setImageIndex,
}: {
  open: boolean;
  onClose: () => void;
  imageUrls: string[];
  imageIndex: number;
  setImageIndex: React.Dispatch<React.SetStateAction<number>>;
}) {
  const images = React.useMemo(
    () =>
      imageUrls.map((src, index) => ({
        id: `message-image-${index}`,
        src,
        alt: `Full size image ${index + 1}`,
      })),
    [imageUrls]
  );

  return (
    <PhotoModal
      open={open}
      onOpenChange={isOpen => {
        if (!isOpen) onClose();
      }}
      images={images}
      activeIndex={imageIndex}
      onActiveIndexChange={setImageIndex}
      title="Image preview"
      closeButtonLabel="Close image preview"
    />
  );
}
